export const EMPTY_STATE_IMG = {
  default: 'https://ucarecdn.com/702ecda9-6277-4dbd-9b85-89980393e5e5/emptystate.svg',
  event: 'https://ucarecdn.com/576a77fc-875f-4009-ad2f-1395f901e60c/noevents.svg',
  course: 'https://ucarecdn.com/576a77fc-875f-4009-ad2f-1395f901e60c/noevents.svg',
  thumbnail: 'https://ucarecdn.com/b55ef792-691b-4afe-8205-9b7490074254/nothumbnail.svg',
};

export const DEFAULT_IMG_ALT = {
  default: 'no content.',
  event: 'no events.',
  course: 'no courses.',
  thumbnail: 'no thumbnail.',
};
